import {FlexPage} from '@hconnect/common/components'
import {Stack} from '@mui/material'

type LayoutProps = {
  titleSlot?: React.ReactNode
  aboveTitleSlot?: React.ReactNode
  plantStatusKpisSlot: React.ReactNode
  expertSystemUsageSlot: React.ReactNode
  operationHoursSlot: React.ReactNode
  myTasksSlot: React.ReactNode
  downtimeByCategorySlot: React.ReactNode
  qualityParametersSlot: React.ReactNode
}

export const PlantDashboardMobileLayout: React.FC<LayoutProps> = ({
  titleSlot,
  aboveTitleSlot,
  plantStatusKpisSlot,
  expertSystemUsageSlot,
  operationHoursSlot,
  myTasksSlot,
  downtimeByCategorySlot,
  qualityParametersSlot
}) => {
  return (
    <FlexPage
      title={titleSlot}
      aboveTitle={aboveTitleSlot}
      nameHeaderSx={{mt: aboveTitleSlot ? 0 : undefined}}
    >
      <Stack spacing={1} useFlexGap flex={1}>
        {plantStatusKpisSlot}
        {operationHoursSlot}
        {qualityParametersSlot}
        {expertSystemUsageSlot}
        {downtimeByCategorySlot}
        {myTasksSlot}
      </Stack>
    </FlexPage>
  )
}
